<template>
  <div
    class="modal fade"
    id="evaluateInterviewModal"
    tabindex="-1"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <ValidationObserver
          ref="evaluateInterviewRef"
          v-slot="{ handleSubmit }"
        >
          <div class="modal-header">
            <span>面談評估</span>
          </div>
          <div class="modal-body">
            <div class="interview-result-list">
              <label>
                <input
                  type="radio"
                  name="result"
                  value="錄取"
                  v-model="approveInterviewResult.ApprovalResult"
                />
                <div>
                  <eva-icon name="checkmark-circle-2-outline" />
                  <span>錄取</span>
                </div>
              </label>
              <label>
                <input
                  type="radio"
                  name="result"
                  value="考慮中"
                  v-model="approveInterviewResult.ApprovalResult"
                />
                <div>
                  <eva-icon name="checkmark-circle-outline" />
                  <span>考慮中</span>
                </div>
              </label>
              <label>
                <input
                  type="radio"
                  name="result"
                  value="複試"
                  v-model="approveInterviewResult.ApprovalResult"
                />
                <div>
                  <eva-icon name="edit-outline" />
                  <span>複試</span>
                </div>
              </label>
              <label class="decline">
                <input
                  type="radio"
                  name="result"
                  value="不錄取"
                  v-model="approveInterviewResult.ApprovalResult"
                />
                <div>
                  <eva-icon name="close-outline" />
                  <span>不錄取</span>
                </div>
              </label>
            </div>
            <!-- 錄取 -->
            <template v-if="approveInterviewResult.ApprovalResult === '錄取'">
              <div class="form-group">
                <label for="">
                  <span class="mark">*</span>是否確認基本資料
                </label>
                <ValidationProvider
                  ref="backlistReason"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    placeholder="請選擇"
                    v-model="approveInterviewResult.ConfirmBasicCondition"
                  >
                    <el-option label="是" :value="true" />
                    <el-option label="否" :value="false" />
                  </el-select>
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div
                v-if="approveInterviewResult.ConfirmBasicCondition"
                class="form-group"
              >
                <label for=""> <span class="mark">*</span>備註 </label>
                <ValidationProvider
                  ref="backlistReason"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    filterable
                    placeholder="請選擇"
                    v-model="approveInterviewResult.InterviewBasicConditionGuid"
                  >
                    <el-option
                      v-for="condition in AdmitOptions"
                      :key="condition.Guid"
                      :label="condition.Name"
                      :value="condition.Guid"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </template>
            <!-- 不錄取 -->
            <template v-if="approveInterviewResult.ApprovalResult === '不錄取'">
              <div class="form-group">
                <label for=""> <span class="mark">*</span>不錄取原因 </label>
                <ValidationProvider
                  ref="backlistReason"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    filterable
                    placeholder="請選擇"
                    v-model="rejectReasonGuid"
                  >
                    <el-option
                      v-for="reason in Person.ResumeType === 'IDL'
                        ? IdlRejectOptions
                        : DlRejectOptions"
                      :key="reason.Guid"
                      :label="reason.Name"
                      :value="reason.Guid"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div class="form-group">
                <label for=""> <span class="mark">*</span>是否可再邀約 </label>
                <ValidationProvider
                  ref="backlistReason"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    :disabled="
                      rejectReasonGuid ===
                        '00000000-0000-0000-0000-000000000000' ||
                      rejectReasonGuid ===
                        '11111111-1111-1111-1111-111111111111'
                    "
                    v-model="approveInterviewResult.CanInvitationAgain"
                  >
                    <el-option label="可再約" :value="true" />
                    <el-option label="不可再約" :value="false" />
                  </el-select>
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
              <div
                v-if="
                  rejectReasonGuid === '00000000-0000-0000-0000-000000000000' ||
                  rejectReasonGuid === '11111111-1111-1111-1111-111111111111'
                "
                class="form-group"
              >
                <label for=""> <span class="mark">*</span>備註 </label>
                <ValidationProvider
                  ref="backlistReason"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <el-select
                    class="w-100"
                    filterable
                    placeholder="請選擇"
                    v-model="rejectNoteGuid"
                  >
                    <el-option
                      v-for="note in rejectNoteOptions"
                      :key="note.Guid"
                      :label="note.Name"
                      :value="note.Guid"
                    >
                    </el-option>
                  </el-select>
                  <span v-if="errors[0]" class="text-danger ml-1">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </template>
            <div class="form-group">
              <label for="">
                <span>其他備註</span>
              </label>
              <textarea
                type="text"
                rows="5"
                maxlength="100"
                class="form-control"
                v-model="approveInterviewResult.ApprovalResultRemark"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="$store.commit('OpenEvaluateInterviewModal', false)"
            >
              關閉
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="handleSubmit(save)"
            >
              儲存
            </button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions, mapGetters } from "vuex";

export default {
  props: [
    "Source",
    "Person",
    "AdmitOptions",
    "IdlRejectOptions",
    "DlRejectOptions",
  ],
  name: "EvaluateInterviewModal",

  data() {
    return {
      approveInterviewResult: {},

      isNotAdmitReason: null, // true: 不錄取-原因, false: 不錄取-備註
      rejectReasonGuid: null, // 不錄取-原因選項
      rejectNoteGuid: null, // 不錄取-備註選項
      rejectNoteOptions: [], // 不錄取備註
    };
  },

  methods: {
    // 取得面談評估
    getApproveInterview() {
      this.approveInterviewResult = {
        ApprovalResult: this.Person.ApprovalResult,
        ConfirmBasicCondition: this.Person.ConfirmBasicCondition,
        InterviewBasicConditionGuid: this.Person.InterviewBasicConditionGuid,
        CanInvitationAgain: this.Person.CanInvitationAgain,
        ApprovalResultRemark: this.Person.ApprovalResultRemark,
      };

      if (this.Person.IsNotAdmitReason === true) {
        this.rejectReasonGuid = this.Person.InterviewNotAdmitReasonGuid;
      } else if (this.Person.IsNotAdmitReason === false) {
        this.rejectReasonGuid =
          this.Person.ResumeType === "IDL"
            ? "00000000-0000-0000-0000-000000000000"
            : "11111111-1111-1111-1111-111111111111";
        this.rejectNoteGuid = this.Person.InterviewNotAdmitReasonGuid;
      } else {
        this.rejectReasonGuid = null;
        this.rejectNoteGuid = null;
      }

      this.updateLoading(false);
      $("#evaluateInterviewModal").modal("show");
    },

    // 儲存
    save() {
      let interviewNotAdmitReasonGuid;
      if (this.isNotAdmitReason === true) {
        interviewNotAdmitReasonGuid = this.rejectReasonGuid;
      } else if (this.isNotAdmitReason === false) {
        interviewNotAdmitReasonGuid = this.rejectNoteGuid;
      } else {
        interviewNotAdmitReasonGuid = null;
      }
      const params = {
        ...this.approveInterviewResult,
        InterviewId: this.Person.InterviewId,
        Approver: this.$cookies.get("userName"),
        InterviewNotAdmitReasonGuid: interviewNotAdmitReasonGuid,
        IsNotAdmitReason: this.isNotAdmitReason,
      };

      this.$emit("saveApproveInterview", params);
    },

    // 取得 不錄取的[備註]下拉選單
    getRejectNote() {
      this.$api.recruitment
        .getInterviewNotAdmitReason({
          ResumeType: this.Person.ResumeType,
          IsNotAdmitReason: false,
        })
        .then((response) => {
          this.rejectNoteOptions = response.data;
          if (this.Source === "InterviewResult") {
            this.getApproveInterview();
          } else {
            this.updateLoading(false);
            $("#evaluateInterviewModal").modal("show");
          }
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    // 不錄取原因
    rejectReasonGuid: function (newVal) {
      if (newVal) {
        if (
          newVal === "00000000-0000-0000-0000-000000000000" ||
          newVal === "11111111-1111-1111-1111-111111111111"
        ) {
          this.$set(this.approveInterviewResult, "CanInvitationAgain", false);
          this.isNotAdmitReason = false;
        } else {
          this.rejectNoteGuid = null;
          this.isNotAdmitReason = true;
        }
      }
    },

    // 評估結果
    "approveInterviewResult.ApprovalResult": function (newVal, oldVal) {
      if (this.Source === "Interviewed") {
        if (newVal && newVal !== oldVal) {
          if (newVal === "錄取") {
            this.rejectReasonGuid = null;
            this.rejectNoteGuid = null;
            this.isNotAdmitReason = null;
            this.approveInterviewResult.CanInvitationAgain = null;
          } else if (newVal === "不錄取") {
            this.approveInterviewResult.ConfirmBasicCondition = null;
            this.approveInterviewResult.InterviewBasicConditionGuid = null;
          } else {
            this.rejectReasonGuid = null;
            this.rejectNoteGuid = null;
            this.isNotAdmitReason = null;
            this.approveInterviewResult.ConfirmBasicCondition = null;
            this.approveInterviewResult.CanInvitationAgain = null;
            this.approveInterviewResult.InterviewBasicConditionGuid = null;
          }
        }
        this.$refs.evaluateInterviewRef.reset();
      }
    },

    // 開關 modal
    showEvaluateInterview: function (newVal) {
      if (newVal) {
        this.updateLoading(true);
        this.$refs.evaluateInterviewRef.reset();
        this.getRejectNote();
      } else {
        this.approveInterviewResult = {};
        this.isNotAdmitReason = null;
        this.rejectReasonGuid = null;
        this.rejectNoteGuid = null;
        this.rejectNoteOptions = [];
        $("#evaluateInterviewModal").modal("hide");
      }
    },
  },

  computed: {
    ...mapGetters(["showEvaluateInterview"]),
  },

  destroyed() {
    this.approveInterviewResult = {};
    this.isNotAdmitReason = null;
    this.rejectReasonGuid = null;
    this.rejectNoteGuid = null;
    this.rejectNoteOptions = [];
    this.$store.commit("OpenEvaluateInterviewModal", false);
  },
};
</script>
